// exemple:
// const obj = { a: { b: { c: 42 } } };
// const value = getNestedValue(obj, 'a.b.c'); // 42
export default function getNestedValue(obj, path) {
    return path.split('.').reduce((acc, part) => {
        if (acc && acc.hasOwnProperty(part)) {
            return acc[part];
        }
        return undefined;
    }, obj);
}
